import { FC, memo } from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { MButton, MButtonType, MButtonSize, MButtonIconPlacement } from '@marriott/mi-web-ui-kit';
import { StickyCtaProps } from './StickyCta.types';
import { StyledStickyCta } from './StickyCta.styles';

export const StickyCtaConfig = {
  emptyLabel: 'StickyCta',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/stickycta`,
};

export const StickyCtaComp: FC<StickyCtaProps> = memo((props: StickyCtaProps) => {
  const { linkText = '', linkUrl = '', openInaNewTab = false, trackingProperties } = props;

  return (
    <StyledStickyCta data-testid="cobrand-StickyCta" data-component-name="o-cobrand-StickyCta" className="pt-2 pb-4">
      <MButton
        ctaLink={linkUrl}
        trackingProperties={trackingProperties}
        openInANewTab={openInaNewTab}
        openInANewTabText={openInaNewTab ? 'Open in new tab' : undefined}
        buttonType={MButtonType.Primary}
        size={MButtonSize.S}
        className="sticky_cta"
        buttonText={linkText}
        iconPlacement={openInaNewTab ? MButtonIconPlacement.Trailing : MButtonIconPlacement.None}
      />
    </StyledStickyCta>
  );
});

StickyCtaComp.displayName = 'StickyCtaComp';

export const StickyCta = (props: StickyCtaProps) => {
  return (
    <EditableComponent config={StickyCtaConfig} {...props}>
      <StickyCtaComp {...props} />
    </EditableComponent>
  );
};
